import { baasicTranslateOverride } from 'common/constants';

const getErrorMessage = ({ statusCode, data, message }, additionalData = {}) => {
	if (data) {
		if (data.innerException && data.innerException.exceptionMessage) {
			return [baasicTranslateOverride(data.innerException.exceptionMessage), additionalData];
		} else if (data.message) {
			return [baasicTranslateOverride(data.message), additionalData];
		} else if (data.error) {
			return [data.error.toUpperCase(), additionalData];
		} else if (data.errorMessage) {
			return [data.errorMessage.toUpperCase(), additionalData];
		} else if (typeof data === 'string') {
			return [data.toUpperCase(), additionalData];
		} else {
			if (statusCode && [400, 409].includes(statusCode)) {
				return [baasicTranslateOverride(data), additionalData];
			} else if (typeof data === 'string' && data.includes('Cutoff time has passed for required warehouse')) {
				return data;
			} else {
				return ['INTERNALERRORMSG', { ...additionalData, msg: data }];
			}
		}
	} else if (statusCode) {
		return ['INTERNALERRORCODE', { ...additionalData, code: statusCode }];
	} else if (message) {
		return ['INTERNALERRORMSG', { ...additionalData, msg: message }];
	} else {
		return ['INTERNALERROR', additionalData];
	}
};

const formInvalidate = ({ form, err, additionalData }) => {
	const errorMessage = getErrorMessage(err, additionalData);
	form.invalidate(errorMessage);
};

const notificationError = ({ store, err, additionalData }) => {
	const errorMessage = getErrorMessage(err, additionalData);
	store.error(errorMessage);
};

export { formInvalidate, notificationError, getErrorMessage };
